angular.module('myApp').directive('fileModel', function () {
  return {
    scope: {
      'fileModel': '='
    },
    link: function (scope, element) {
      element.bind('change', function (evt) {
        scope.$apply(function () {
          scope.fileModel = evt.target.files[0]
        })
      })
      scope.$on('$destroy', function () {
        element.unbind('change')
      })
    }
  }
})
